import { createSelector } from "reselect";
export const selectConfig = ({ JobPackV3_reducer }) => {
    return JobPackV3_reducer.parentReducer.config;
};
export const selectProfile = ({ JobPackV3_reducer }) => {
    return JobPackV3_reducer.parentReducer.profile;
};
export const selectPageType = ({ JobPackV3_reducer }) => {
    return JobPackV3_reducer.parentReducer.pageType;
};
export const selectMapKey = ({ MainReducer }) => {
    return MainReducer.profile.map_api_key;
};
export const selectDepartments = createSelector(
    [selectProfile],
    ({ departments = false }) => {
        if (departments) return departments;
        else return null;
    }
);
export const selectAreas = createSelector(
    [selectProfile],
    ({ areas = false }) => {
        if (areas) return areas;
        else return null;
    }
);
export const selectReportPermission = createSelector(
    [selectConfig, selectProfile, selectPageType],
    (config = false, profile = false, type = false) => {
        if (config && profile && type) {
            let { access_level } = profile;
            return config[access_level];
        } else {
            return false;
        }
    }
);
export const selectPermission = createSelector(
    [selectConfig, selectProfile, selectPageType],
    (config = false, profile = false, type = false) => {
        if (config && profile && type) {
            let { access_level } = profile;

            switch (type) {
                case "create": {
                    return config[access_level]["jobpack"].create;
                }
                case "edit": {
                    return config[access_level]["jobpack"].update;
                }
                case "view": {
                    return config[access_level]["jobpack"].read;
                }
                default: {
                    return true;
                }
            }
        } else {
            return true;
        }
    }
);
